import { FC, ChangeEventHandler, useRef } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import Dropzone from '../components/Dropzone';

export interface UploaderProps {
    onUpload(files: File[], path?: string): Promise<void>;
    path?: string;
    disabled?: boolean;
}

const Uploader: FC<UploaderProps> = ({ onUpload, path, disabled }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const triggerFileInput = () => {
        const { current } = fileInputRef;
        current && current.click();
    };

    const onFileInput: ChangeEventHandler<HTMLInputElement> = (e: any) => {
        const { target } = e;
        const { files } = target;

        if (files === null || files.length === 0) {
            return;
        }
        onUpload(Array.from(files), path);
        e.target.value = null;
    };

    return (
        <div style={{ display: 'inline' }}>
            <Button circular icon labelPosition='left' onClick={triggerFileInput} disabled={disabled}>
                <Icon name='upload' />
                Upload
            </Button>

            <input
                hidden
                multiple
                type="file"
                ref={fileInputRef}
                id="file"
                onChange={onFileInput}
            />

            <Dropzone onDrop={onUpload} path={path}/>
        </div>
    );
};


export default Uploader;